
<script>
import * as Quill from 'quill';
  export default {
    created(){
    },
    data() {
        return {
            header: {
              token: this.$store.state.env.userInfo.token
            },
            fileList: [],
            editorOption: {
                modules: {
                    // toolbar: [
                    //     ['bold', 'image'],
                    //     // ['bold', 'italic', 'underline', 'strike'],
                    //     // ['blockquote', 'code-block'],
                    //     // [{ 'header': 1 }, { 'header': 2 }],
                    //     // [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                    //     // [{ 'script': 'sub' }, { 'script': 'super' }],
                    //     // [{ 'indent': '-1' }, { 'indent': '+1' }],
                    //     // [{ 'direction': 'rtl' }],
                        // [{ 'size': ['small', false, 'large', 'huge'] }],
                    //     // [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                    //     // [{ 'font': [] }],
                    //     // [{ 'color': [] }, { 'background': [] }],
                    //     // [{ 'align': [] }],
                    //     // ['clean'],
                    //     // ['link']
                    // ]
                    toolbar: {
                        container: [['bold', 'image', { 'align': [] }]],
                        handlers: {
                            'image': function(val) {
                                if (val) {
                                    console.log(document.getElementById('quill-img'));
                                    document.getElementById('quill-img').click()
                                } else {
                                    this.quill.format('image', false);
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    props: {
        article: {
            required: true,
            type: Object
        },
        props: {
            type: String,
            default: 'content'
        },
        action: {
            type: String
        }
    },
    methods: {
        uploadImg() {
            console.log(122);
        },
        onEditorBlur(editor) {
        },
        onEditorFocus(editor) {
        },
        onEditorReady(editor) {
        },
        uploadSuccess(res) {
            if(res.code !== 200) {
                this.$message.error('文件上传失败')
                return;
            }
            const quill = this.$refs.myTextEditor.quill
            // 获取光标所在位置
            const length = quill.getSelection().index;
            // 插入图片，res为服务器返回的图片链接地址
            quill.insertEmbed(length, 'image', res.data);
            // 调整光标到最后
            quill.setSelection(length + 1);
        }
    },
    computed: {
        editor() {
            return this.$refs.myTextEditor.quill
        }
    },
    mounted() {
        var fontSizeStyle = Quill.import('attributors/style/size')
        fontSizeStyle.whitelist = ['12px', '14px', '16px', '20px', '24px', '36px']
        Quill.register(fontSizeStyle, true)
        var Align = Quill.import('attributors/style/align');
        Align.whitelist = ['right', 'center', 'justify'];
        Quill.register(Align, true);
    },
    // watch: {
    //     content(val, old) {
    //         console.log(val, old);
    //     }
    // }
  }
</script>

<template>
<div>
    <el-upload style="display:none"
        class="upload-demo"
        :action="action"
        accept="image/*"
        :limit="1"
        :headers="header"
        :on-success="uploadSuccess"
        :file-list="fileList">
        <el-button size="small" type="primary" id="quill-img">点击上传</el-button>
    </el-upload>
    <quill-editor
      ref="myTextEditor"
      v-model="article[props]"
      :options="editorOption"
      @blur="onEditorBlur($event)"
      @focus="onEditorFocus($event)"
      @ready="onEditorReady($event)">
    </quill-editor>
</div>
</template>
